import $ from 'jquery';
import 'whatwg-fetch';

import './lib/jquery.touchSwipe';
import './lib/sprout-slide';
import { shuffleArr } from './common';

import '../css/lib/sprout-slide.css';
import '../css/index/banner-slide.css';

(() => {
	fetch('static/json/cases.json')
		.then((response) => response.json())
		.then((json) => {
			/**
			 * get case.json after shuffleArr()
			 */
			const caseArr = shuffleArr(json.cases);

			Array.prototype.forEach.call(caseArr, (caseVal, index) => {
				if (index < 4) {
					const slider = document.querySelector(`li:nth-child(${index + 1}) .banner-slide`);
					if (!slider) return;

					slider.setAttribute('style', `background-image: url(${caseVal.thumb})`);
					slider.children[0].innerText = caseVal.brand.substr(0, 1);
					slider.children[1].children[1].innerText = caseVal.brand;
					slider.children[1].children[2].innerText =
						document.querySelector('.window-section.-slide-footer').getAttribute('data-lang') === 'tw' ?
							caseVal.desc
							:
							caseVal.enDesc;
					slider.children[1].children[3].setAttribute(
						'href',
						caseVal.link === null ? caseVal.website : caseVal.link,
					);
					slider.children[1].children[3].setAttribute(
						'target',
						caseVal.link === null ? '_target' : '_self',
					);
				}
			});

			$('#slide-footer').sproutSlide({
				width: window.innerWidth,
				slideNum: 1,
				duration: 900,
				interval: 12000,
			});
		});
})();



// WEBPACK FOOTER //
// ./src/js/slide-footer.js